import { Grid } from '@mui/material';
import { useState } from 'react';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  useCheckPermissions,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchRubros } from '@/shared/actions/erp';
import { GeneralTable, SingleButton } from '@/shared/components/ui';
import type { Contrato, Rubro } from '@/shared/interfaces';
import { useColumnsRubrosCliente } from '../../../hooks';
import ClienteRuboLibreModal from './ClienteRuboLibreModal';

export type ClienteFibraRubroTabProps = {
  contract: Contrato;
};

const ClienteFibraRubroTab: React.FC<ClienteFibraRubroTabProps> = ({
  contract,
}) => {
  useCheckPermissions(PermissionsEnum.api_view_rubro);

  ///* local state -------------------------
  const [openRubroLibre, setOpenRubroLibre] = useState<boolean>(false);
  const [openRubroServicio, setOpenRubroServicio] = useState<boolean>(false);

  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data -------------------------
  const {
    data: rubrosPagingRes,
    isLoading,
    isRefetching,
  } = useFetchRubros({
    enabled: !!contract?.id_contrato,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      ...filterObject,
      cliente: contract?.cliente,
      concepto: searchTerm,
    },
  });

  useLoaders(isLoading || isRefetching);

  ///* columns -------------------------
  const { columnsRubrosClientView } = useColumnsRubrosCliente({
    contract,
  });

  return (
    <Grid item container xs={12}>
      {/* ================= buttons ================= */}
      <Grid item container xs={12} my={3}>
        <span className="spacer"></span>

        <Grid item container md={6} justifyContent="flex-end">
          <SingleButton
            newCustomButton
            justifyContent="flex-end"
            label="RUBRO LIBRE"
            variant="text"
            onClick={() => {
              setOpenRubroLibre(true);
            }}
          />

          <SingleButton
            newCustomButton
            justifyContent="flex-end"
            label="RUBRO DE SERVICIO"
            variant="text"
            onClick={() => {
              setOpenRubroServicio(true);
            }}
          />
        </Grid>
      </Grid>

      {/* ================= table ================= */}
      <Grid item xs={12}>
        <GeneralTable<Rubro>
          columns={columnsRubrosClientView}
          data={rubrosPagingRes?.data?.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // filters - llega al back
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // // search
          enableGlobalFilter={false}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={rubrosPagingRes?.data?.count}
          // // actions
          // custom actions - custom colum
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          //positionActionsColumn='last'
        />
      </Grid>

      {/* ================= modals ================= */}
      <ClienteRuboLibreModal
        open={openRubroLibre}
        setOpen={setOpenRubroLibre}
        contract={contract}
      />
    </Grid>
  );
};

export default ClienteFibraRubroTab;
